/* ==========================================================================
   lma-adv-motion.js : la couche de mouvement de la page advertorial.
   --------------------------------------------------------------------------
   Trois responsabilites, et une regle de survie.

   REGLE DE SURVIE : c est CE fichier qui pose la classe `adv-motion-ready` sur
   <html>. Tout le CSS qui masque quoi que ce soit est conditionne a cette
   classe. Consequence : si ce script ne se charge pas, ne s execute pas, ou
   plante, RIEN n est masque et la page reste entierement lisible. Un filet de
   securite temporise revele tout au bout de 2,5 secondes quoi qu il arrive.
   Lecon du 2026-08-24 : trois mecaniques d animation successives ont laisse une
   section entierement noire parce que l etat masque etait l etat par defaut.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduit) return;                      // mouvement refuse : on ne masque rien, on ne bouge rien.

  root.classList.add('adv-motion-ready');

  /* Largeur de la barre de defilement, exposee en variable CSS.
     100vw INCLUT la barre : une section pleine largeur en width:100vw deborde
     donc de sa largeur des qu une barre est affichee, et la page gagne un
     defilement horizontal. Mesure du 2026-08-25 en 1280px : 15px de debord sur
     trois sections. Les sections corrigent leur largeur avec cette variable. */
  function mesurerBarre() {
    var sbw = window.innerWidth - root.clientWidth;
    root.style.setProperty('--adv-sbw', (sbw > 0 ? sbw : 0) + 'px');
  }
  mesurerBarre();
  window.addEventListener('resize', mesurerBarre, { passive: true });
  /* Une seule mesure au demarrage ne suffit pas : tant que la page est plus
     courte que la fenetre, aucune barre n existe et la mesure rend 0. Elle
     apparait quand les images finissent de charger et que la page s allonge.
     Releve du 2026-08-25 en 1280 : la variable etait restee a 0 et trois
     sections pleine largeur debordaient de 7px. On remesure donc au chargement
     complet, et a chaque changement de hauteur du document. */
  window.addEventListener('load', mesurerBarre);
  if (typeof ResizeObserver === 'function') {
    var ro = new ResizeObserver(mesurerBarre);
    ro.observe(root);
    if (document.body) ro.observe(document.body);
  } else {
    var n = 0, tick = setInterval(function () {
      mesurerBarre();
      if (++n > 20) clearInterval(tick);
    }, 250);
  }

  function toutReveler() {
    var l = document.querySelectorAll('[data-adv-reveal]:not(.is-revealed)');
    for (var i = 0; i < l.length; i++) l[i].classList.add('is-revealed');
  }
  // Filet : quoi qu il arrive ensuite, plus rien n est masque apres 2,5 s.
  setTimeout(toutReveler, 2500);

  if (!('IntersectionObserver' in window)) { toutReveler(); return; }

  /* ---- 1. Reveal au defilement, avec cascade par groupe ------------------ */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-revealed');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function armer() {
    document.querySelectorAll('[data-adv-reveal]').forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      io.observe(el);
    });
    // Cascade : chaque enfant direct d un groupe recoit son rang, le CSS s en
    // sert comme retard. Pose en JS pour ne pas ecrire 12 regles nth-child.
    document.querySelectorAll('[data-adv-stagger]').forEach(function (g) {
      var n = 0;
      Array.prototype.forEach.call(g.children, function (c) {
        c.style.setProperty('--adv-i', n++);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armer);
  else armer();

  /* ---- 2. Barre d achat collante ---------------------------------------- */
  /* Elle n apparait qu une fois le bloc d achat depasse : avant, elle ferait
     doublon avec le bouton du hero et mangerait la ligne de flottaison. */
  var barre = document.querySelector('[data-adv-sticky]');
  var achat = document.getElementById('adv-buy');
  if (barre && achat) {
    var sentinelle = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // visible quand le bloc d achat est SORTI par le haut
        var passe = e.boundingClientRect.bottom < 0;
        barre.classList.toggle('is-visible', passe);
      });
    }, { threshold: 0 });
    sentinelle.observe(achat);
  }

  /* ---- 3. Barres de distribution : elles poussent a l entree ------------- */
  var jauges = document.querySelectorAll('[data-adv-grow]');
  if (jauges.length) {
    var ioJauge = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        // La largeur cible vit dans l attribut, jamais dans le style inline :
        // si ce script ne tourne pas, le CSS de repli affiche la barre pleine.
        el.style.width = (el.getAttribute('data-adv-grow') || '0') + '%';
        ioJauge.unobserve(el);
      });
    }, { threshold: 0.4 });
    jauges.forEach(function (j) { ioJauge.observe(j); });
  }
})();

/* ======================================================================
   ANNEAU DE PROMOTION DU PALIER RETENU
   Recette relevee le 2026-08-25 dans le DOM de Ionix, composant Kaching :
   une bande pleine a rayon 40, et par dessus un SVG qui pose le texte le
   long d un rectangle arrondi rentre de 11,2 et de rayon 35,2, trace DEUX
   fois bout a bout pour que l enroulement soit continu. Vingt-deux motifs
   sont repartis sur un tour, en alternant le libelle et une puce, et chacun
   glisse d exactement un tour, ce qui rend la boucle invisible. Leur vitesse
   mesuree : 20 unites de chemin par seconde.

   Quatre bandes droites, ce que nous avions avant, laissent les angles nus.
   La bande pleine reste posee en CSS : sans JavaScript, l anneau est la,
   simplement sans texte.
   ====================================================================== */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  /* Bande ramenee de 24 a 16 : Pierre la trouvait trop epaisse le 2026-08-25.
     Le chemin se rentre donc de la MOITIE de la bande, soit 8, pour que le
     texte coure pile au milieu de l epaisseur et non contre un bord. Le rayon
     du chemin suit le rayon exterieur moins ce rentre. */
  /* VALEURS RELEVEES CHEZ IONIX LE 2026-08-25, a l identique.
     Bande de 24, rayon exterieur 40, carte interieure a 16. Le chemin est
     rentre de 11,2 et non de 12 : leur texte repose SUR le trace, sans
     dominant-baseline, et ce demi-pixel de decalage vers le haut est ce qui
     le recentre optiquement dans la bande. Reproduire 12 + baseline centree
     donne un rendu different, teste.
     Le rayon 35,2 n est pas la mi-epaisseur geometrique (28,8) : ils prennent
     plus large, ce qui adoucit les angles et evite que les glyphes pivotants
     ne sortent de la bande. */
  var BANDE = 24;
  var RENTRE = 11.2;
  var RAYON = 35.2;
  var RAYON_EXT = 40;
  /* Le nombre de motifs n est PAS fixe chez eux : il suit la longueur du
     contour, un motif tous les ~45 unites. Mesures : 22 motifs pour un tour
     de 1018, 32 pour un tour de 1418. Une constante donnerait un texte trop
     serre sur les grandes cartes et trop clairseme sur les petites. */
  var PAS_MOTIF = 45;
  var VITESSE = 20;
  var sobre = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var compteur = 0;

  function chemin(w, h) {
    var i = RENTRE;
    var r = Math.min(RAYON, (h - 2 * i) / 2, (w - 2 * i) / 2);
    if (!(r > 0)) return null;
    var t = 'M ' + (i + r) + ' ' + i +
            ' H ' + (w - i - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (w - i) + ' ' + (i + r) +
            ' V ' + (h - i - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (w - i - r) + ' ' + (h - i) +
            ' H ' + (i + r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + i + ' ' + (h - i - r) +
            ' V ' + (i + r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (i + r) + ' ' + i;
    return t + ' ' + t.replace(/^M/, 'L') + ' Z';
  }

  function poser(porte) {
    var boite = porte.parentNode;
    if (!boite) return;
    var w = Math.round(boite.offsetWidth), h = Math.round(boite.offsetHeight);
    if (w < 60 || h < 60) return;
    if (porte.dataset.advPose === w + 'x' + h) return;
    var d = chemin(w, h);
    if (!d) return;

    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'lma-adv-marquee__svg');
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('aria-hidden', 'true');

    var id = 'adv-anneau-' + (++compteur);
    var pth = document.createElementNS(NS, 'path');
    pth.setAttribute('fill', 'none');
    pth.setAttribute('id', id);
    pth.setAttribute('d', d);
    svg.appendChild(pth);

    // La longueur d un tour est la moitie du trace, puisqu il est double.
    var tour = pth.getTotalLength() / 2;
    if (!(tour > 0)) return;
    var duree = tour / VITESSE;

    /* Nombre de motifs deduit du tour, comme chez eux. Pair, pour que le
       libelle et la puce alternent proprement d un bout a l autre. */
    var MOTIFS = Math.max(8, Math.round(tour / PAS_MOTIF / 2) * 2);

    var txt = document.createElementNS(NS, 'text');
    txt.setAttribute('text-anchor', 'middle');
    /* Pas de dominant-baseline : chez eux le texte repose sur le trace, et
       c est le rentre de 11,2 qui le recentre dans la bande. */
    var libelle = porte.getAttribute('data-adv-marquee') || (window.LuveonI18n && window.LuveonI18n.adv_marquee_default) || 'Limited offer';

    for (var k = 0; k < MOTIFS; k++) {
      var depart = tour * (k + 1) / MOTIFS;
      var tp = document.createElementNS(NS, 'textPath');
      tp.setAttribute('href', '#' + id);
      tp.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + id);
      tp.setAttribute('startOffset', depart);
      if (!sobre) {
        var an = document.createElementNS(NS, 'animate');
        an.setAttribute('attributeName', 'startOffset');
        an.setAttribute('repeatCount', 'indefinite');
        an.setAttribute('from', depart);
        an.setAttribute('to', depart + tour);
        an.setAttribute('dur', duree + 's');
        tp.appendChild(an);
      }
      tp.appendChild(document.createTextNode(k % 2 === 0 ? libelle : '•'));
      txt.appendChild(tp);
    }
    svg.appendChild(txt);

    porte.textContent = '';
    porte.appendChild(svg);
    porte.dataset.advPose = w + 'x' + h;
  }

  function poserTout() {
    var l = document.querySelectorAll('[data-adv-marquee]');
    for (var i = 0; i < l.length; i++) poser(l[i]);
  }

  function armer() {
    poserTout();
    /* La carte change de hauteur quand on passe d un palier a l autre : on
       repose l anneau a chaque changement de taille. */
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(poserTout);
      var l = document.querySelectorAll('[data-adv-marquee]');
      for (var i = 0; i < l.length; i++) if (l[i].parentNode) ro.observe(l[i].parentNode);
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') setTimeout(poserTout, 60);
    });
    window.addEventListener('resize', poserTout, { passive: true });
    window.addEventListener('load', poserTout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armer);
  else armer();
})();
